import { ClipLoader } from "react-spinners";

import { H3, InternalLink, LoadingSpinner } from "@sorcery/ui";

import { collectionPath } from "~/utils/paths";
import { api } from "~/utils/trpc";
import { CollectionListTeaser } from "../../../../components/organisms/collection/collectionlistteaser/CollectionListTeaser";

export const CollectionTab = () => {
  /************************************************************************************
   * data fetching
   */
  const { data: collectionlist, isPending: collectionLoading } =
    api.collection.getCollectionlistBySession.useQuery();

  /*************************************************************************************************************************
   * react helper hooks
   */
  const isLoading = collectionLoading;

  return (
    <div className="mb-8 w-full duration-700 animate-in fade-in">
      {isLoading ? (
        <div className="my-8 lg:ml-4">
          <ClipLoader
            className={"!hidden !border-l-white !border-r-white !border-t-white lg:!block"}
            size={30}
          />
          <span className="block lg:hidden">
            <LoadingSpinner />
          </span>
        </div>
      ) : collectionlist?.length ? (
        <CollectionListTeaser cards={collectionlist} />
      ) : (
        <div className="my-10 flex duration-700 animate-in fade-in">
          <div className="max-w-md">
            <H3 className="!mb-1">No Collection... Yet</H3>
            <div>
              <InternalLink href={collectionPath} color="primary">
                Set it up now
              </InternalLink>{" "}
              <span>to start tracking your collection in Curiosa.</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
